import { FunctionComponent } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Telecommunication } from './TelecomunicationPage';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { useResponsive } from '../../contexts/ResponsiveContext';

interface TelecommunicationTemplateProps {
    telecommunications: Telecommunication[];
}

const TelecommunicationTemplate: FunctionComponent<TelecommunicationTemplateProps> = ({
    telecommunications,
}) => {
    const { isScreenMd, isScreenSm, isScreenXs } = useResponsive();

    const renderTelecommunication = (telecom: Telecommunication) => (
        <>
            <Typography
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    fontWeight: 600,
                    lineHeight: '30px',
                    textAlign: 'left',
                    marginTop: isScreenMd || isScreenSm || isScreenXs ? '1rem' : '0',
                }}
            >
                {telecom.title}
            </Typography>
            <Typography
                component="div"
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '24px',
                    textAlign: 'left',
                    marginTop: isScreenMd || isScreenSm || isScreenXs ? '1rem' : '0',
                }}
                dangerouslySetInnerHTML={{ __html: telecom.description }}
            ></Typography>
            <Box sx={{ marginTop: '3rem' }}>
                <Button
                    onClick={() => (window.location.href = telecom.linkRoute)}
                    sx={{
                        width: '150px',
                        height: '40px',
                        padding: '8px 10px',
                        gap: '10px',
                        borderRadius: '5px',
                        backgroundColor: '#E5673E',
                        color: 'white',
                        fontSize: '16px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        lineHeight: '24px',
                        transition: 'none',
                        textTransform: 'capitalize',
                        '&:hover': {
                            background: 'linear-gradient(0deg, #B75332 0%, #E5673E 100%)',
                        },
                    }}
                >
                    {telecom.linkText}
                </Button>
            </Box>
        </>
    );

    // 組成每個區塊的資料
    const telecomSections = [
        {
            telecom: telecommunications[0],
            backgroundColor: '#F2F2F2',
            bigScreenTextLeft: true,
        },
        {
            telecom: telecommunications[1],
            backgroundColor: 'white',
            bigScreenTextLeft: false,
        },
    ];

    return (
        <>
            {telecomSections.map((section, index) =>
                section.telecom ? (
                    <ResponsiveSplitSection
                        key={index}
                        textContent={renderTelecommunication(section.telecom)}
                        backgroundColor={section.backgroundColor}
                        smallScreenTextFirst={false}
                        imageSrc={section.telecom.image ?? ''}
                        bigScreenAlignItem="flex-start"
                        bigScreenTextLeft={section.bigScreenTextLeft}
                    />
                ) : null
            )}
        </>
    );
};

export default TelecommunicationTemplate;
